import axios from "axios";
import { baseUrl } from "config/settings";

axios.defaults.baseURL = baseUrl; // request url
axios.defaults.timeout = 30000; // response time
axios.defaults.headers.get["Content-Type"] = "application/json; charset=utf-8";

/**
 * @description: FETCH request axios request
 * @param {String}
 * @return {Promise}
 */
export async function getAPI(url, params = {}, token = null) {
  axios.defaults.headers.Authorization = `Bearer ${token}`;
  return await axios.get(url, { params });
}

/**
 * @description: POST request method
 * @param {String}
 * @return {Promise}
 */
export async function postAPI(url, params = {}, token = null) {
  axios.defaults.headers.Authorization = `Bearer ${token}`;
  return await axios.post(url, params);
}

/**
 * @description: PUT request method
 * @param {String}
 * @return {Promise}
 */
export async function putAPI(url, params = {}, token = null) {
  axios.defaults.headers.Authorization = `Bearer ${token}`;
  return await axios.put(url, params);
}
/**
 * @description: PATCH request method
 * @param {String}
 * @return {Promise}
 */
export async function patchAPI(url, params = {}, token = null) {
  axios.defaults.headers.Authorization = `Bearer ${token}`;
  return await axios.patch(url, params);
}

/**
 * @description: DELETE request method
 * @param {String}
 * @return {Promise}
 */
export async function deleteAPI(url, params = {}, token = null) {
  axios.defaults.headers.Authorization = `Bearer ${token}`;
  return await axios.delete(url, { data: params });
}
